<template>
  <div class="printingsurfacesize-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('printingsurfacesize_edit')" />

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-checkerboard</v-icon>{{$t('profile.printingsurface.sizes')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <PrintingSurfaceSizeFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.size" slot-scope="{ item }">
                  {{ item['size'] }}
                </template>

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import PrintingSurfaceSizeFilterForm from '../../components/printingsurfacesize/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'PrintingSurfaceSizeList',
  servicePrefix: 'PrintingSurfaceSize',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    PrintingSurfaceSizeFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.printingsurface.size'), value: 'size' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['size'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('printingsurfacesize', {
      items: 'list'
    }),
    ...mapFields('printingsurfacesize', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('printingsurfacesize', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
